<style lang="scss" scoped>
.tabs {
  border-bottom: 1px solid #f4f6f8;
  display: flex;
  flex-flow: row;
  .tab {
    color: #c4c4c4;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    margin-right: 40px;
    padding-bottom: 15px;
    margin-bottom: 2px;
    cursor: pointer;
    transition: color 0.2s, box-shadow 0.2s;
    &:hover,
    &.active {
      color: #333333;
    }
    &.active {
      box-shadow: 0px 4px 0 -1px var(--primary);
    }
  }
}
.trial-banner {
  background: #d4eddb;
}
.statistics-block {
  width: 100%;
  height: 141px;
  border-radius: 4px;
  background-color: #f4f6f8;
  justify-content: center;
  padding: 0 30px;
}
.form-footer {
  position: fixed;
  width: calc(100% - 467px);
  left: 467px;
  background: #fff;
  padding: 15px 80px 40px 80px;
  bottom: 0;
}
.increment-trial-input {
  .placeholder {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 100px;
    margin: auto;
    height: 24px;
    color: #b6b6b6;
  }
  input {
    background: transparent;
    border: 1px solid rgba(53, 82, 61, 0.38);
    border-radius: 4px 0 0 4px !important;
  }
}
</style>

<template>
  <div v-if="workspace">
    <div class="header-spacer"></div>
    <div class="subnav-spacer"></div>
    <div class="d-flex col-12 sub-nav">
      <h3 class="fw-b fs-32 ff-os-b mb-0">{{ workspace.name }}</h3>
      <a href="javascript:void(0)" @click="handleDeleteWorkspace" class="ml-auto my-auto btn btn-danger">
        <i class="fal fa-trash mr-15 my-auto"></i>
        Delete
      </a>
    </div>

    <div class="tabs mb-30">
      <div class="tab" :class="{ active: tab === 'dashboard' }" @click="tab = 'dashboard'">Dashboard</div>
      <div class="tab" :class="{ active: tab === 'company' }" @click="tab = 'company'">Bedrijfsgegevens</div>
      <div class="tab" :class="{ active: tab === 'users' }" @click="tab = 'users'">Gebruikers</div>
    </div>

    <template v-if="tab === 'dashboard'">
      <div v-if="workspace.end_date" class="trial-banner p-15 d-flex flex-row mb-30">
        <i class="fal fa-clock my-auto fs-32 mr-15"></i>
        <div class="d-flex flex-column my-auto">
          <!-- Scenario 'Active Plan':  -->
          <!-- User has an active plan and can prolong it -->
          <template v-if="workspace.status === 'active'">
            <p class="ff-l fs-17 fw-b text-dark mb-0">{{ $moment(workspace.end_date).diff($moment(), 'days') }} dagen over in het plan</p>
            <p class="ff-l fw-l fs-16 text-dark mb-0">Toegang tot {{ workspace.end_date | moment('DD MMM YYYY') }}</p>
          </template>

          <!-- Scenario 'Expired Plan':  -->
          <!-- User has an expired plan and can reset it -->
          <template v-else-if="workspace.status === 'expired'">
            <p class="ff-l fs-17 fw-b text-dark mb-0">Het plan is vervallen</p>
            <p class="ff-l fw-l fs-16 text-dark mb-0">Geen toegang meer</p>
          </template>

          <!-- Scenario 'Active Trial':  -->
          <!-- User has an active trial and can prolong it -->
          <template v-else-if="workspace.status === 'trial'">
            <p class="ff-l fs-17 fw-b text-dark mb-0">{{ $moment(workspace.end_date).diff($moment(), 'days') }} dagen over in trial</p>
            <p class="ff-l fw-l fs-16 text-dark mb-0">Toegang tot {{ workspace.end_date | moment('DD MMM YYYY') }}</p>
          </template>

          <!-- Scenario 'Expired Trial':  -->
          <!-- User has an expired trial and can reset it -->
          <template v-else-if="workspace.status === 'trial_expired'">
            <p class="ff-l fs-17 fw-b text-dark mb-0">De trial is vervallen</p>
            <p class="ff-l fw-l fs-16 text-dark mb-0">Geen toegang meer</p>
          </template>
        </div>

        <a v-if="!show_prolong_trial" class="ml-auto my-auto ff-l fs-16 fw-b text-dark" href="#" @click="show_prolong_trial = !show_prolong_trial"> {{ workspace.status.includes('trial') ? 'Trial' : 'Plan' }} {{ workspace.status.includes('_expired') ? 'herstarten' : 'verlengen' }} </a>
        <div v-else class="ml-auto my-auto">
          <div class="input-group mb-3  increment-trial-input">
            <span class="placeholder">dagen</span>
            <input v-model="increment_trial_days" type="number" class="form-control mb-0" placeholder="+ dagen" aria-label="add_days" />
            <div class="input-group-append">
              <button @click="incrementTrialDays" class="btn btn-primary" type="button">Verleng</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-30">
        <div class="col">
          <div class="statistics-block d-flex flex-column text-center">
            <p class="mb-15 fs-40 ff-l fw-b text-secondary">{{ workspace.users_count }}</p>
            <p class="mb-0 fs-11 ff-l fw-b text-secondary text-uppercase">totaal aantal gebruikers</p>
          </div>
        </div>
        <div class="col">
          <div class="statistics-block d-flex flex-column text-center">
            <p class="mb-15 fs-40 ff-l fw-b text-secondary">{{ workspace.containers_count }}</p>
            <p class="mb-0 fs-11 ff-l fw-b text-secondary text-uppercase">totaal aantal boards</p>
          </div>
        </div>
        <div class="col">
          <div class="statistics-block d-flex flex-column text-center">
            <p class="mb-15 fs-40 ff-l fw-b text-secondary">{{ workspace.files_count }}</p>
            <p class="mb-0 fs-11 ff-l fw-b text-secondary text-uppercase">totaal aantal Documenten</p>
          </div>
        </div>
        <div class="col">
          <div class="statistics-block d-flex flex-column text-center">
            <p class="mb-15 fs-40 ff-l fw-b text-secondary"><span class="small">€</span>{{ workspace.price }}</p>
            <p class="mb-0 fs-11 ff-l fw-b text-secondary text-uppercase">abonnement</p>
          </div>
        </div>
      </div>
      <div v-if="workspace.creator">
        <p class="ff-l fs-17 fw-b text-dark mb-15">Contactpersoon/Beheerder</p>
        <div class="users">
          <div class="d-flex flex-row mb-15">
            <el-avatar :user="workspace.creator" size="a-40 mr-15"></el-avatar>
            <div class="d-flex flex-column">
              <p class="mb-0 fs-16 ff-l fw-b text-secondary">{{ workspace.creator.first_name }} {{ workspace.creator.last_name }}</p>
              <p class="mb-0 fs-11 ff-l fw-n text-light">{{ workspace.creator.phone }} {{ workspace.creator.email }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <el-form v-if="tab === 'company' && workspace" @submit="submit" :loading="loading" :success="success" :disabled="loading || vat_loading">
      <h2 class="mb-30 fw-b fs-24">{{ $t('views.admin.workspace.company.title') }}</h2>

      <div class="form-row mb-30">
        <el-input class="col-12 col-lg-6 mb-0" v-model="data.company" type="text" name="Bedrijfsnaam" rule="required" :label="$t('forms.labels.company')" :placeholder="$t('forms.placeholders.company')"></el-input>
        <el-input class="col-12 col-lg-6 mb-0" v-model="data.vat" @input="handleVATUpdate" type="text" name="BTW nummer" rule="required|min:10|max:14" :label="$t('forms.labels.vat_number')" :placeholder="$t('forms.placeholders.vat_number')"></el-input>
      </div>

      <div class="form-row mb-30">
        <el-input
          class="col-12 col-lg-6 mb-0"
          v-model="data.slug"
          @input="
            (v) => {
              data.slug = slugify(v);
            }
          "
          type="text"
          name="workspace"
          rule="required|min:2|max:255"
          :label="$t('forms.labels.slug')"
          :placeholder="$t('forms.placeholders.workspace')"
        ></el-input>
        <el-select v-model="data.commercial_status" class="col-12 col-lg-6 mb-0" name="commercial_status" :options="commercial_statuses" :label="$t('forms.labels.commercial_status')" :placeholder="$t('forms.placeholders.commercial_status')"></el-select>
      </div>

      <div class="form-row mb-45">
        <el-input class="col-12 col-lg-8 mb-15" v-model="data.street" type="text" name="street" rule="required" :label="$t('forms.labels.street')" :placeholder="$t('forms.placeholders.street')"></el-input>
        <el-input class="col-12 col-lg-4 mb-15" v-model="data.number" type="text" name="number" rule="required" label="&#160;" :placeholder="$t('forms.placeholders.number')"></el-input>
        <el-input class="col-12 col-lg-4 mb-0" v-model="data.zip" type="text" name="zip" rule="required" :hasLabel="false" :placeholder="$t('forms.placeholders.zip')"></el-input>
        <el-input class="col-12 col-lg-8 mb-0" v-model="data.city" type="text" name="city" rule="required" :hasLabel="false" :placeholder="$t('forms.placeholders.city')"></el-input>
      </div>
    </el-form>
    <vue-good-table v-if="tab === 'users' && workspace && workspace.users" class="col-12 mt-30" :columns="structure" :search-options="{ enabled: true }" :rows="workspace.users" styleClass="vgt-table">
      <template slot="table-row" slot-scope="slotProps">
        <span v-if="slotProps.column.field === 'user'" class="d-flex flex-row align-contents-center">
          <el-avatar class="my-auto" :user="slotProps.row"></el-avatar>
          <p class="my-auto ml-8">{{ slotProps.row.first_name }} {{ slotProps.row.last_name }}</p>
        </span>
        <span v-else>
          {{ slotProps.formattedRow[slotProps.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import { mapActions } from 'vuex';
import { ElAvatar, ElInput } from '@/components/elements/_index';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import HasForm from '@/components/forms/has-form';
import RemoveWorkspace from '@/popups/admin/workspaces/remove';

export default {
  name: 'views.admin.workspace',

  mixins: [HasForm],

  components: {
    ElInput,
    ElAvatar,
    VueGoodTable,
    ElForm: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElForm'),
    ElSelect: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElSelect'),
  },

  data() {
    return {
      /*
            | Page specific data
            */
      exists: false,
      tab: 'dashboard',
      show_prolong_trial: false,
      increment_trial_days: 5,

      structure: [
        { width: '250px', label: this.$t('forms.labels.user'), field: 'user', sortable: true, sortFn: this.userSort },
        { width: '300px', label: this.$t('forms.labels.email'), field: 'email' },
        { width: '200px', label: 'Registratiedatum', field: 'created_at', type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'PP', thClass: 'text-left', tdClass: 'text-left' },
        { field: this.$t('forms.labels.lastname'), hidden: true },
        { field: this.$t('forms.labels.firstname'), hidden: true },
      ],
      commercial_statuses: [{ value: 'test', label: this.$t('status.commercial.test') }, { value: 'demo', label: this.$t('status.commercial.demo') }, { value: 'trial', label: this.$t('status.commercial.trial') }, { value: 'active', label: this.$t('status.commercial.active') }, { value: 'inactive', label: this.$t('status.commercial.inactive') }, { value: 'dispose', label: this.$t('status.commercial.dispose') }],

      data: {
        id: '',
        company: '',
        vat: '',
        slug: '',
        commercial_status: null,
        street: '',
        city: '',
        zip: '',
        number: '',
      },

      vat_loading: false,
    };
  },

  methods: {
    ...mapActions(['postAdminTrialUpdate']),

    incrementTrialDays() {
      this.postAdminTrialUpdate({ id: this.$route.params.id, data: { days: this.increment_trial_days } }).then((workspace) => {
        this.show_prolong_trial = false;
        this.workspace = workspace;
      });
    },

    /*
        | Verify workspace
        | ------------------
        | Verify if the workspace
        | exists or not.
        */
    check: _.debounce(function() {
      this.verifyWorkspace(this.slug).then((res) => {
        this.exists = res.exists;
      });
    }, 500),

    /*
        | Debounce check
        | ------------------
        | Handles the form submission
        | but only after typing has stopped for x seconds
        */
    handleVATUpdate: _.debounce(function() {
      this.vat_loading = true;
      if (this.data.vat.length >= 10 && this.data.vat.length <= 14) {
        this.$store
          .dispatch('workspace/verifyVat', this.data.vat)
          .then((response) => {
            this.vat_loading = false;
            if (response.valid) {
              this.data.street = response.address.street;
              this.data.number = response.address.number;
              this.data.zip = response.address.zip_code;
              this.data.city = response.address.city;
            } else {
              this.handleError({ error: this.$t('user.company.btw_error') });
            }
          })
          .catch((e) => this.handleError(e));
      }
    }, 1500),

    handleDeleteWorkspace() {
      this.$modal.show(RemoveWorkspace, { workspaces: [this.workspace] }, { adaptive: true, height: '370', width: '400' });
    },

    /*
        | Update workspace
        | ------------------
        | Handles the form submission
        | for workspace detail information
        */
    submit() {
      this.loading = true;
      this.$store
        .dispatch('admin/updateWorkspace', this.data)
        .then(() => {
          this.loading = false;
          this.success = true;
          this.$toasted.show(this.toastHtml(this.$t('views.admin.workspace.company.update_success')), {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch((e) => this.handleError(e));
    },
  },

  computed: {
    workspace() {
      return this.$store.getters['admin/viewingWorkspace'];
    },
  },

  watch: {
    workspace: {
      handler: function(workspace) {
        if (!workspace) return;
        for (let field in this.data) {
          this.data[field] = workspace[field];
        }
      },
      immediate: true,
    },
  },
};
</script>
